query getUserDataPermissions {
  userDataPermissions: getUserDataPermissions {
    objectId
    type
    consent
  }
}
